import "./chat-message-item.css";
import { BsCheck2, BsCheck2All } from "react-icons/bs";
import moment from "moment";

const ChatMessageItem = ({ username, msg, time, is_right_side, status }) => {
  return (
    <div className={is_right_side ? "msg-element is-right" : "msg-element"}>
      {/* Usernames is displayed when it came to group messages */}
      <h3 className="msg-e-top">{username}</h3>
      <div className="msg-e-text">{msg}</div>
      {/* <div className="msg-e-audio">I am feeling exhausted</div> */}
      {/* <div className="msg-e-image">I am feeling exhausted</div> */}
      <div className="msg-e-bottom">
        <span>{moment(time).format("LT")}</span>
        {is_right_side && status === "sent" && <BsCheck2 className="icon" />}
        {is_right_side && status === "delivered" && (
          <BsCheck2All className="icon is-delivered" />
        )}
        {is_right_side && status === "read" && (
          <BsCheck2All className="icon is-read" />
        )}
      </div>
    </div>
  );
};

export default ChatMessageItem;
